<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      InstaSel: ["Select", "Facebook", "Instagram"],
      FaceSel: ["Select", "www.facebook.com", "www.instagram.com"],
      NaFaceSel: ["Select", "Facebook", "Instagram"],
      URlSelect: ["Select", "www.facebook.com", "www.instagram.com"],
      SocialName: ["Select", "Instagram", "Facebook"],
      ProSosel: ["Select", "www.facebook.com", "www.instagram.com"],
      SocialNameOne: ["Select", "Instagram", "Facebook"],
      ProSoselOne: ["Select", "www.facebook.com", "www.instagram.com"],
      SocialNameTwo: ["Select", "Instagram", "Facebook"],
      ProSoselTwo: ["Select", "www.facebook.com", "www.instagram.com"],
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Social Profiles</h5>
          </div>
        </div>
        <!-- Social Profiles -->
        <div class="row">
          <div class="col-12">
            <div class="row align-items-center">
              <div class="col-xl-5 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <vue-select :options="InstaSel" id="instasel" placeholder="Select" />
                </div>
              </div>
              <div class="col-xl-6 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">URL</label>
                  <vue-select :options="FaceSel" id="facesel" placeholder="Select" />
                </div>
              </div>
              <div class="col-xl-1 col-lg-2 col-sm-12">
                <label>&nbsp;</label>
                <div class="d-flex align-items-center form-check form-switch mb-3">
                  <input type="checkbox" id="status-1" class="form-check-input" />
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-xl-5 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <vue-select :options="NaFaceSel" id="nafacesel" placeholder="Select" />
                </div>
              </div>
              <div class="col-xl-6 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">URL</label>
                  <vue-select :options="URlSelect" id="urlselect" placeholder="Select" />
                </div>
              </div>
              <div class="col-xl-1 col-lg-2 col-sm-12">
                <label>&nbsp;</label>
                <div class="d-flex align-items-center form-check form-switch mb-3">
                  <input type="checkbox" id="status-two" class="form-check-input" />
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-xl-5 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <vue-select
                    :options="SocialName"
                    id="socialname"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-xl-6 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">URL</label>
                  <vue-select :options="ProSosel" id="prososel" placeholder="Select" />
                </div>
              </div>
              <div class="col-xl-1 col-lg-2 col-sm-12">
                <label>&nbsp;</label>
                <div class="d-flex align-items-center form-check form-switch mb-3">
                  <input type="checkbox" id="status-3" class="form-check-input" />
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-xl-5 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <vue-select
                    :options="SocialNameOne"
                    id="socialnameone"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-xl-6 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">URL</label>
                  <vue-select
                    :options="ProSoselOne"
                    id="prososelone"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-xl-1 col-lg-2 col-sm-12">
                <label>&nbsp;</label>
                <div class="d-flex align-items-center form-check form-switch mb-3">
                  <input type="checkbox" id="status-4" class="form-check-input" />
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-xl-5 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">Name</label>
                  <vue-select
                    :options="SocialNameTwo"
                    id="socialnametwo"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-xl-6 col-lg-5 col-sm-12">
                <div class="mb-3">
                  <label class="form-label">URL</label>
                  <vue-select
                    :options="ProSoselTwo"
                    id="prososeltwo"
                    placeholder="Select"
                  />
                </div>
              </div>
              <div class="col-xl-1 col-lg-2 col-sm-12">
                <label>&nbsp;</label>
                <div class="d-flex align-items-center form-check form-switch mb-3">
                  <input type="checkbox" id="status-5" class="form-check-input" />
                </div>
              </div>
            </div>

            <div class="acc-submit d-flex justify-content-end">
              <a href="javascript:void(0);" class="btn btn-light me-3">Cancel</a>
              <a href="javascript:void(0);" class="btn btn-dark">Save Changes</a>
            </div>
          </div>
        </div>
        <!-- /Social Profiles -->
      </div>
    </div>
    <!-- /Page Wrapper -->
    <!-- Delete Account -->
    <div class="modal fade custom-modal" id="del-account">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div
            class="modal-header d-flex align-items-center justify-content-between border-bottom"
          >
            <h5 class="modal-title">Delete Account</h5>
            <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
              ><i class="ti ti-circle-x-filled fs-20"></i
            ></a>
          </div>
          <form action="javascript:void(0);">
            <div class="modal-body">
              <p class="mb-3">
                Are you sure you want to delete This Account? To delete your account, Type
                your password.
              </p>
              <div class="mb-0">
                <label class="form-label">Password</label>
                <div class="pass-group">
                  <input
                    :type="isPasswordVisible ? 'text' : 'password'"
                    class="form-control pass-input"
                    placeholder="*************"
                  />
                  <span
                    @click="togglePasswordVisibility"
                    :class="
                      isPasswordVisible
                        ? 'toggle-password feather-eye'
                        : 'toggle-password feather-eye-off'
                    "
                  ></span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-2"
                data-bs-dismiss="modal"
                >Cancel</a
              >
              <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Delete Account -->
  </div>
</template>
